import { lazy } from "react";

export const CandidateDashboard = lazy(() => import("./CandidateDashboard"));
export const UpdateCandidateProfile = lazy(() =>
  import("./UpdateCandidateProfile")
);
export const CandidateFeaturedJobs = lazy(() =>
  import("./CandidateFeaturedJobs")
);
